
import { getRequest, postRequest,monitorGateway} from "@/utils/request";
import qs from "qs";
window.qs = qs;
// 驾驶舱-电 electricity
export const cockpitApi = {
  // 告警情况统计
  queryAlarmStatistic: () => {
    return getRequest(`${monitorGateway}/cockpitel/alarm`);
  },
  // 24小时实时负载统计
  queryLoadStatistic: () => {
    return getRequest(`${monitorGateway}/cockpitel/load`);
  },
    // 计划停电情况统计
    queryPowerCut: () => {
      return getRequest(`${monitorGateway}/cockpitel/power/plan`);
    },
      // 电能质量情况统计
  queryPowerQuality: () => {
    return getRequest(`${monitorGateway}/cockpitel/quality`);
  },
  
      // 实时数据
      queryRealData: () => {
        return getRequest(`${monitorGateway}/cockpitel/real`);
      },
        // 抢修/维修情况统计
    queryTaskStatistic: () => {
      return getRequest(`${monitorGateway}/cockpitel/task`);
    },
      // 获取总用电量（GWh）
      queryTotalPower: () => {
        return getRequest(`${monitorGateway}/cockpitel/total/electricity`);
      },
         // 近七日用电趋势
         queryWeekElectricity: () => {
          return getRequest(`${monitorGateway}/cockpitel/trend`);
        },
          // 各中心新旧设备占比
          queryDevice: () => {
            return getRequest(`${monitorGateway}/cockpitel/equipment`);
          },
               // 尖峰平谷
               queryPeriodTime: (params) => {
                return getRequest(`${monitorGateway}/cockpitel/peak`,params);
              },
};
